import { VITE_STRAPI_URL } from './getBaseUrl';

export const getMediaUrl = url => {
  if (!url) return '';

  if (url.startsWith('http')) {
    return url;
  }

  if (url.startsWith('/assets')) {
    return url;
  }

  return `${VITE_STRAPI_URL.replace(/\/$/, '')}${url}`;
};
